import axios from "@/index";
const codeStyle = {
  state: {
    codeStyleInfoData: []
  },
  getters: {},
  actions: {
    getCodeStyleById: ({ commit, state, dispatch }, config = {}) => {
      return new Promise((resolve, reject) => {
        axios
          .get(config.url, config.params)
          .then(response => {
            if (response.status === 200) {
              commit(
                "setCodeStyleById",
                (state, { codeStyleInfoData: response.data })
              );
              resolve(response.data);
            } else {
              reject("error");
            }
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  mutations: {
    setCodeStyleById(state, action) {
      state.codeStyleInfoData = action.codeStyleInfoData;
    }
  }
};
export default codeStyle;
